import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'adm-add' | 'adm-edit' | 'adm-delete' | 'adm-cancel' | 'adm-save' | 'adm-impersonate';
  size?: 'sm' | 'md' | 'lg';
}

const variantClasses: Record<string, string> = {
  primary: 'btn-save',
  secondary: 'btn-can',
  danger: 'btn-out',
  ghost: 'btn-pd-add',
  'adm-add': 'adm-btn-add',
  'adm-edit': 'adm-btn-edit',
  'adm-delete': 'adm-btn-delete',
  'adm-cancel': 'adm-btn-cancel',
  'adm-save': 'adm-btn-save',
  'adm-impersonate': 'adm-btn-impersonate',
};

const admVariants = new Set(['adm-add', 'adm-edit', 'adm-delete', 'adm-cancel', 'adm-save', 'adm-impersonate']);

const sizeStyles: Record<string, React.CSSProperties> = {
  sm: { padding: '6px 12px', fontSize: '12px' },
  md: { padding: '9px 16px', fontSize: '14px' },
  lg: { padding: '13px 22px', fontSize: '15px' },
};

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  className = '',
  style,
  children,
  ...rest
}) => {
  const baseClass = variantClasses[variant] ?? 'btn-save';
  const sizeStyle = admVariants.has(variant) ? undefined : sizeStyles[size];
  return (
    <button
      className={`${baseClass}${className ? ` ${className}` : ''}`}
      style={sizeStyle || style ? { ...sizeStyle, ...style } : undefined}
      {...rest}
    >
      {children}
    </button>
  );
};

export { Button };
